import { React } from 'react';

import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '../components/protectedRoutes';
import HistoricoPedidos from '../pages/pedidos/historicoPedidos';
import NovoMaterial from '../pages/pedidos/novoMaterial';
import NovoPedido from '../pages/pedidos/novoPedido';

const RoutePedidosOeM = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role='PedidosOeM'/>}>
                <Route path='novoMaterial' element={<NovoMaterial/>}/>
                <Route path='novoPedido' element={<NovoPedido/>}/>
                <Route path='historicoPedidos' element={<HistoricoPedidos/>}/>
            </Route>
        </Routes>
    );
};

export default RoutePedidosOeM;
